import {convertDateToSpecificFormat} from '../common/util/date';
import {reverseShortDate} from '../common/constants/datesFormat';

export const getUrl = (initDate, endDate, typeTwc) => {
  const parseInitDate = convertDateToSpecificFormat(initDate, reverseShortDate);
  const parseEndDate = convertDateToSpecificFormat(endDate, reverseShortDate);
  const params = `&initDate=${parseInitDate}&endDate=${parseEndDate}&typeTwc=${typeTwc}`;
  return params;
};

export const CAMPAIGN_STATUS = [
  {'key': 'TODOS', 'text': 'TODOS', 'value': 'TODOS'},
  {'key': 'ACTIVO', 'text': 'ACTIVO', 'value': 'A'},
  {'key': 'INACTIVO', 'text': 'INACTIVO', 'value': 'I'},
];

export const transportTypes = [
  {'text': 'Aereo', 'value': 'A'},
  {'text': 'Marítimo', 'value': 'M'},
];

export const orderTypes = [
  {'text': 'Normal', 'value': '00'},
  {'text': 'INEN', 'value': '01'},
];

export const warrantyCampaignsStatus = [
  {'text': 'TODOS', 'value': 'TODOS'},
  {'text': 'ATENDIDO', 'value': 'A'},
  {'text': 'NO ATENDIDO', 'value': 'N'},
];

export const HOUR_PRICE = 25;
